<script>
import appConfig from "@/app.config";

import {notificationMethods} from "@/state/helpers";
import {mapGetters} from "vuex";
import general from "@/components/menus/general";

import Loading from "@/components/app/Loading";

export default {
  name: "app",
  page: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === "function" ? title(this.$store) : title;
      return title ? `${title} | ${appConfig.title}` : appConfig.title;
    },
  },
  components: {
    Loading,
  },
  mounted() {
  },
  watch: {
    /**
     * Clear the alert message on route change
     */
    // eslint-disable-next-line no-unused-vars
    $route(to, from) {
      // clear alert on location change
      this.validateMenuRoute(to);
      this.clearNotification();
    },
  },
  methods: {
    clearNotification: notificationMethods.clear,
    validateMenuRoute(to) {
      let match = false;

      // Search in general routes
      for (let item of general.items) {
        if (item.routeName === to.name) {
          return true;
        }
      }

      // Search in menu routes
      if (!match)
        for (let item of this.getActiveInterfaceMenu.items) {
          for (let subitem of item.subItems) {
            if (subitem.show && !subitem.permission ? true : this.$can(subitem.permission)) {
              if (to.name === "default") {
                return this.$router.push({name: subitem.routeName});
              }
              if (subitem.routeName === to.name) return true;
            }
          }
        }
    },
    // google tag manager 
    async enableGoogleAnalytics(){
      var googleAnalyticsId = 'GTM-W92B6HNC'
      if(process.env.VUE_APP_ENV == 'production')
        this.activateGtm(window,document,'script','dataLayer',googleAnalyticsId);
    },

    activateGtm(w,d,s,l,i){
      w[l]=w[l]||[];
      w[l].push({'gtm.start': new Date().getTime(),event:'gtm.js'});
      var f=d.getElementsByTagName(s)[0],
      j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';
      j.async=true;
      j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;
      f.parentNode.insertBefore(j,f);
    },
  },
  computed: {
    ...mapGetters("menu", ["getActiveInterfaceMenu"]),
  },
  created() {
    this.enableGoogleAnalytics();
  },
};
</script>


<template>
  <div id="app">
    <Loading/>
    <RouterView/>
  </div>
</template>
